// Lib
import { CompletessInfo } from 'features/Dealers/Performance/Widgets/ProfileCompleteness/state/types';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';

export interface ActionGetCompletenessAPI extends Action {
    iddealer?: string
}

export const getCompletenessAPI = (iddealer?: string): ActionGetCompletenessAPI => ({
    type: ACTIONS.GET_COMPLETENESS_API_REQUEST,
    iddealer
});

export interface ActionGetCompletenessApiSuccess extends Action {
    completenessInfo: CompletessInfo
}

export const getCompletenessAPISuccess = (completenessInfo: CompletessInfo): ActionGetCompletenessApiSuccess => ({
    type: ACTIONS.GET_COMPLETENESS_API_SUCCESS,
    completenessInfo
});

export const getCompletenessAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_COMPLETENESS_API_ERROR,
    error
});